import whiteKanban from "../../assets/whiteKanban.webp";
import deleteBoard from "../../assets/deleteBoard.webp";
import editBoard from "../../assets/editBoard.webp";
import editSubtaskKanban from "../../assets/editSubtaskKanban.webp";
import editTaskKanban from "../../assets/editTaskKanban.webp";
import kanban from "../../assets/kanban.webp";
import { Project } from "../../components/project";
import json from "./kanban.json";
import { IoIosArrowForward } from "react-icons/io";

export const Kanban = () => {
  const imageMap = {
    whiteKanban,
    kanban,
    deleteBoard,
    editBoard,
    editSubtaskKanban,
    editTaskKanban,
  };

  return (
    <div className="flex flex-col sm:items-start items-center text-primary gap-3 animate-fade-down animate-once animate-duration-1000 animate-delay-0 animate-ease-in-out animate-normal animate-fill-both">
      <Project json={json} imageMap={imageMap} />
      <div className="sm:text-[30px] text-[25px] font-[500] mt-3">
        Link to the project
      </div>
      <div className="flex justify-center gap-x-4 text-xl">
        <IoIosArrowForward className="text-secondary mt-1" />
        <a
          rel="noreferrer"
          href={"https://kanban-786.netlify.app/"}
          target="_blank"
          className="text-[16px] text-secondary hover:opacity-90"
        >
          Kanban Project Management Tool
        </a>
      </div>
    </div>
  );
};
